<template>
  <div>
    <app-header id="header"></app-header>

    <div class="container">
      <div class="row">
        <div v-for="img in images" :key="img" class="col-sm-12 col-md-6 col-lg-3 my-3 text-center">
          <a target="_blank" :href="computeAssetsUrl('img/bg', img)">
            <div class="zoom-container">
              <img class="img-fluid" :src="computeAssetsUrl('img/sm', img)" alt="Image">
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AppHeader from '@/components/AppHeader'
  import AppFooter from '@/components/AppFooter'
  import CallIcon from 'vue-ionicons/dist/md-call'
  import PhonePortraitIcon from 'vue-ionicons/dist/md-phone-portrait'
  import PinIcon from 'vue-ionicons/dist/md-pin'
  import BriefcaseIcon from 'vue-ionicons/dist/md-briefcase'
  import MailIcon from 'vue-ionicons/dist/md-mail'
  import GlobeIcon from 'vue-ionicons/dist/md-globe'

  export default {
    name: 'Index',
    components: {
      AppHeader,
      CallIcon,
      PhonePortraitIcon,
      PinIcon,
      BriefcaseIcon,
      MailIcon,
      GlobeIcon,
      AppFooter,
    },
    data() {
      return {
        images: [
          'Manuel-1.jpg',
          'Manuel-10.jpg',
          'Manuel-11.jpg',
          'Manuel-12.jpg',
          'Manuel-13.jpg',
          'Manuel-14.jpg',
          'Manuel-15.jpg',
          'Manuel-16.jpg',
          'Manuel-17.jpg',
          'Manuel-18.jpg',
          'Manuel-19.jpg',
          'Manuel-2.jpg',
          'Manuel-3.jpg',
          'Manuel-4.jpg',
          'Manuel-5.jpg',
          'Manuel-6.jpg',
          'Manuel-7.jpg',
          'Manuel-8.jpg',
          'Manuel-9.jpg',
          'car-1.jpg',
          'car-10.jpg',
          'car-11.jpg',
          'car-12.jpg',
          'car-13.jpg',
          'car-14.jpg',
          'car-15.jpg',
          'car-16.jpg',
          'car-17.jpg',
          'car-18.jpg',
          'car-19.jpg',
          'car-2.jpg',
          'car-20.jpg',
          'car-21.jpg',
          'car-22.jpg',
          'car-23.jpg',
          'car-24.jpg',
          'car-25.jpg',
          'car-26.jpg',
          'car-27.jpg',
          'car-28.jpg',
          'car-29.jpg',
          'car-3.jpg',
          'car-30.jpg',
          'car-31.jpg',
          'car-32.jpg',
          'car-33.jpg',
          'car-34.jpg',
          'car-4.jpg',
          'car-5.jpg',
          'car-6.jpg',
          'car-7.jpg',
          'car-8.jpg',
          'car-9.jpg',
          'testarossa_1.jpg',
          'testarossa_2.jpg',
          'testarossa_3.jpg',
          'testarossa_4.jpg',
          'testarossa_5.jpg',
          'testarossa_6.jpg',
        ],
      }
    },
    methods: {
      computeAssetsUrl(type, file) {
        let ctx = null

        // somehow the first argument passed to require.context must be a string literal🤷
        switch (type) {
          case 'img/sm':
            ctx = require.context('../assets/img/sm', true, /\.jpg/)
            break
          case 'img/bg':
          default:
            ctx = require.context('../assets/img/bg', true, /\.jpg/)
        }

        return ctx('./' + file)
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../styles/variables";
  @import "../styles/custom";
  @import "~bootstrap/scss/bootstrap-grid";

  .zoom-container {
    img {
      height: 300px;
      object-fit: cover;

      transform-origin: center center;
      transition: transform .25s, visibility .25s ease-in;
    }

    @include media-breakpoint-up(md) {
      &:hover img {
        transform: scale(1.2);
      }
    }
  }

</style>
